module.exports = __webpack_public_path__ + "static/img/05.63b4dda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/horse/05.png
// module id = urrB
// module chunks = 1